import "./Examples.scss";
import { Component } from "react";

export default class Examples extends Component {
  state = {
    selectedCategory: "All"
  };

  categories = ["All", "Restaurant", "Retail", "Health & Wellness", "Professional Services"];

  examplePosts = [
    {
      category: "Restaurant",
      industry: "Sushi Restaurant",
      image: "/images/examples/sushi-post.jpg",
      description: "Weekend special promotion"
    },
    {
      category: "Restaurant",
      industry: "Bakery",
      image: "/images/examples/bakery-post.jpg",
      description: "New seasonal menu items"
    },
    {
      category: "Retail",
      industry: "Boutique Store",
      image: "/images/examples/retail-post.jpg",
      description: "Flash sale announcement"
    },
    {
      category: "Health & Wellness",
      industry: "Spa & Massage",
      image: "/images/examples/spa-post.jpg",
      description: "Wellness tips and promotions"
    },
    {
      category: "Professional Services",
      industry: "Marketing Agency",
      image: "/images/examples/marketing-post.jpg",
      description: "Industry insights and tips"
    },
    {
      category: "Restaurant",
      industry: "Burger Restaurant",
      image: "/images/examples/burger-post.jpg",
      description: "Customer appreciation day"
    }
  ];

  filterPosts = () => {
    if (this.state.selectedCategory === "All") {
      return this.examplePosts;
    }
    return this.examplePosts.filter(post => post.category === this.state.selectedCategory);
  };

  render() {
    const filteredPosts = this.filterPosts();

    return (
      <div className="examples-container">
        <div className="examples-header">
          <h1>Real Examples from Our Clients</h1>
          <p>See the quality of content our expert marketing team creates for businesses like yours</p>
        </div>

        <div className="examples-filters">
          {this.categories.map((category) => (
            <button
              key={category}
              className={`filter-btn ${this.state.selectedCategory === category ? 'active' : ''}`}
              onClick={() => this.setState({ selectedCategory: category })}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="examples-grid">
          {filteredPosts.map((post, index) => (
            <div key={index} className="example-card">
              <div className="example-image-wrapper">
                <div className="example-placeholder">
                  <div className="placeholder-icon">📱</div>
                  <p className="placeholder-text">{post.industry}</p>
                  <p className="placeholder-desc">{post.description}</p>
                </div>
              </div>
              <div className="example-info">
                <span className="example-category">{post.category}</span>
                <h3>{post.industry}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="examples-cta">
          <h2>Ready to see what we can create for your business?</h2>
          <a href="https://calendly.com/dealigense/demo" target="_blank" rel="noreferrer">
            <button className="btn-primary cta-btn">Request a Demo</button>
          </a>
        </div>
      </div>
    );
  }
}
